/**
 * Generic option type for select dropdowns and similar components.
 */
export interface SelectOption {
  value?: string | number;
  text?: string;
  label?: string;
  selected?: boolean;
}

/**
 * Status variant for property status badges.
 * Maps to Badge component variant prop.
 */
export type StatusVariant = 'success' | 'destructive' | 'warning';

/**
 * Option for radio button groups.
 */
export interface RadioOption {
  label: string;
  value: string;
  id?: string;
}

/**
 * Alert/toast variant types.
 */
export enum Variants {
  DEFAULT = 'default',
  SUCCESS = 'success',
  ERROR = 'error',
  WARNING = 'warning',
  INFO = 'info',
  CLEANUP = 'cleaning',
}
